import React, { useCallback, useState, useEffect } from "react";
import * as Yup from "yup";
import {
  Row,
  Col,
  FormGroup,
  Label,
} from "reactstrap";
import Title from "../title";
import { Field } from "formik";
import { customStyle, gateTypes, weekDays } from "../appointment/utils";
import ReactSelect from "react-select";

const multiSelectStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    width: "100%",
    height: "auto",
    boxShadow: "none",
    padding: "8px 0px",
    cursor: "text",
    borderRadius: "4px",
  }),
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isFocused ? "#f0f0f0" : "white",
    color: "black",
    cursor: isDisabled ? "not-allowed" : "default",
    "&:hover": {
      backgroundColor: "purple",
      color: "white",
    },
  }),
  multiValueLabel: (styles) => ({
    ...styles,
    color: "white",
    backgroundColor: "purple",
    padding: "5px 16px",
    borderRadius: "6px 0 0 6px",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    background: "purple",
    color: "white",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "white",
      color: "purple",
    },
    borderRadius: "0 6px 6px 0",
  }),
};

export const FormFirstStep = (formikProps) => {
  const { errors, touched, values, setFieldValue, classes = [] } = formikProps;
  const scheduleOptions = [
    {
      key: "none",
      label: "None"
    },
    {
      key: "custom",
      label: "Custom"
    }
  ];
  const addDay = (fieldNAme, value) => {
    const array = values[fieldNAme] || [];
    const found = array.some((el) => el === value);
    if (found) {
      return;
    }
    array.push(value);
    setFieldValue(fieldNAme, array);
  };
  const removeDay = (fieldNAme, value) => {
    const array = values[fieldNAme] || [];

    const selectedArray = array.filter(function (item) {
      return item !== value;
    });
    setFieldValue(fieldNAme, selectedArray);
  };
  const addTimesRangeTo = (fieldNAme, value, ind) => {
    const array = values[fieldNAme] || [];

    array[ind] = {
      from: array[ind] && array[ind].from !== undefined ? array[ind].from : "",
      to: value,
    };
    setFieldValue(fieldNAme, array);
  };
  const addTimesRangeFrom = (fieldNAme, value, ind) => {
    const array = values[fieldNAme] || [];
    array[ind] = {
      from: value,
      to: array[ind] && array[ind].to !== undefined ? array[ind].to : "",
    };
    setFieldValue(fieldNAme, array);
  };
  return (
    <div className="">
      <div className="basic-info">
        <div className="members-info-wrapper info-wrapper border-bottom-1 blk-padding-y">
          <div className="info-title">
            <Title title="Gate Info" />
          </div>
          <div className="info">
            <Row>
              <Col md={6}>
                <FormGroup className="custom-inputs">
                  <Field
                    type="text"
                    name="name"
                    id="Gate name"
                    maxLength={50}
                    placeholder={"Name"}
                    className={`form-control ${errors.name &&
                      touched.name &&
                      "is-invalid"}`}
                  />
                  {errors.name && touched.name ? (
                    <div className="invalid-feedback">{`${errors.name}`}</div>
                  ) : null}
                  <Label for="name">
                    Gate Name
                  </Label>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="custom-inputs">
                  <ReactSelect
                    name="type"
                    options={gateTypes}
                    className={`form-control custom-inputs p-0 h-100 d-flex align-items-center mb-0 ${errors.type &&
                      touched.type &&
                      "is-invalid"}`}
                    styles={customStyle}
                    value={gateTypes.find(opt => opt.key === values.type) || null}
                    onChange={(type) => setFieldValue("type", type.key)}
                  />
                  {errors.type && touched.type ? (
                    <div className="invalid-feedback">{`${errors.type}`}</div>
                  ) : null}
                  <Label for="type">
                    Gate Type
                  </Label>
                </FormGroup>
              </Col>
            </Row>
            {values.type === "Studio" && (
              <Row>
                <Col md={12}>
                  <FormGroup className="custom-inputs">
                    <ReactSelect
                      name="linkedClasses"
                      options={classes.map(c => ({ value: c.id, label: c.name }))}
                      isMulti
                      hideSelectedOptions={false}
                      closeMenuOnSelect={false}
                      styles={multiSelectStyles}
                      className={`form-control p-0 h-100 d-flex align-items-center custom-inputs`}
                      placeholder="Select classes to link with this gate"
                      value={classes
                        .filter(c => (values.linkedClasses || []).includes(c.id))
                        .map(c => ({ value: c.id, label: c.name }))
                      }
                      onChange={(selectedOptions) => {
                        const selectedIds = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
                        console.log('Selected class IDs:', selectedIds);
                        setFieldValue("linkedClasses", selectedIds);
                      }}
                    />
                    <Label for="linkedClasses">
                      Linked Classes
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            )}
            {/* Male and Female Schedule fields - hidden but kept in code */}
            {false && <Row>
              <Col md={6}>
                <FormGroup className="custom-inputs mb-md-0">
                  <ReactSelect
                    name="maleSchedule"
                    options={scheduleOptions}
                    className={`form-control custom-inputs p-0 h-100 d-flex align-items-center mb-0 ${errors.maleSchedule &&
                      touched.maleSchedule &&
                      "is-invalid"}`}
                    styles={customStyle}
                    defaultValue= {scheduleOptions[0]}
                    onChange={(maleSchedule) => setFieldValue("maleSchedule", maleSchedule.key)}
                  />
                  {errors.maleSchedule && touched.maleSchedule ? (
                    <div className="invalid-feedback">{`${errors.maleSchedule}`}</div>
                  ) : null}
                  <Label for="maleSchedule">
                    Male Schedule
                  </Label>
                </FormGroup>
              </Col>
              {values.maleSchedule == "custom" && <section className="p-4">
                <div className="info-title">
                  <Title title="Select Male days"/>
                </div>
                <div className="mb-3">
                  {weekDays.map((day, idx) => {
                    return (
                      <div className="subscription-plan-list-element">
                        <div className="selction-box mt-0 px-0 mr-3">
                          <div className="checkboxes-list form-check">
                            <label
                              className={`container-blk form-check-label`}
                              for={`editinlineRadio5-male${idx + 5}`}
                            >
                              <Field
                                className="form-check-input max-width-fit-content"
                                type="checkbox"
                                name="maleDays"
                                id={ `editinlineRadio5-male${idx + 5}`}
                                value={day.value}
                                checked={
                                  values.maleDays && values.maleDays.includes(day.value)
                                }
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    addDay("maleDays", e.target.value);
                                  } else {
                                    removeDay("maleDays", e.target.value);
                                  }
                                }}
                              />
                              <span class="checkmark"></span>
                              {day.label}
                            </label>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="info-title">
                  <Title title="Select Male Time"/>
                </div>
                <div className="mb-4">
                  <Row>
                    <Col md={4}>
                      <FormGroup className="custom-inputs select-box mb-md-0 ">
                        <Field
                          type="time"
                          onChange={(e) => {
                            addTimesRangeFrom("maleTime", e.target.value, 0);
                          }}
                          id={"maleFrom"}
                          name="maleFrom"
                          className={`form-control input time-input`}
                        />
                        <Label for="maleFrom" className="">
                          {"Male Start Time"}
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup className="custom-inputs select-box mb-md-0 ">
                        <Field
                          type="time"
                          onChange={(e) => {
                            addTimesRangeTo("maleTime", e.target.value, 0);
                          }}
                          id={"maleTo"}
                          name="maleTo"
                          className={`form-control input time-input `}
                        />
                        <Label for="maleTo" className="">
                          {"Male End Time"}
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </section>}

              <Col md={6}>
                <FormGroup className="custom-inputs mb-md-0">
                  <ReactSelect
                    name="femaleSchedule"
                    options={scheduleOptions}
                    className={`form-control custom-inputs p-0 h-100 d-flex align-items-center mb-0 ${errors.femaleSchedule &&
                      touched.femaleSchedule &&
                      "is-invalid"}`}
                    styles={customStyle}
                    defaultValue= {scheduleOptions[0]}
                    onChange={(femaleSchedule) => setFieldValue("femaleSchedule", femaleSchedule.key)}
                  />
                  {errors.femaleSchedule && touched.femaleSchedule ? (
                    <div className="invalid-feedback">{`${errors.femaleSchedule}`}</div>
                  ) : null}
                  <Label for="femaleSchedule">
                    Female Schedule
                  </Label>
                </FormGroup>
              </Col>
              {values.femaleSchedule == "custom" && <section className="p-4">
                <div className="info-title">
                  <Title title="Select Female days"/>
                </div>
                <div className="mb-3">
                  {weekDays.map((day, idx) => {
                    return (
                      <div className="subscription-plan-list-element">
                        <div className="selction-box mt-0 px-0 mr-3">
                          <div className="checkboxes-list form-check">
                            <label
                              className={`container-blk form-check-label`}
                              for={`editinlineRadio5-female${idx + 5}`}
                            >
                              <Field
                                className="form-check-input max-width-fit-content"
                                type="checkbox"
                                name="femaleDays"
                                id={ `editinlineRadio5-female${idx + 5}`}
                                value={day.value}
                                checked={
                                  values.femaleDays && values.femaleDays.includes(day.value)
                                }
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    addDay("femaleDays", e.target.value);
                                  } else {
                                    removeDay("femaleDays", e.target.value);
                                  }
                                }}
                              />
                              <span class="checkmark"></span>
                              {day.label}
                            </label>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="info-title">
                  <Title title="Select Female Time"/>
                </div>
                <div className="mb-0">
                  <Row>
                    <Col md={4}>
                      <FormGroup className="custom-inputs select-box mb-md-0 ">
                        <Field
                          type="time"
                          onChange={(e) => {
                            addTimesRangeFrom("femaleTime", e.target.value, 0);
                          }}
                          id={"femaleFrom"}
                          name="femaleFrom"
                          className={`form-control input time-input`}
                        />
                        <Label for="femaleFrom" className="">
                          {"Female Start Time"}
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup className="custom-inputs select-box mb-md-0 ">
                        <Field
                          type="time"
                          onChange={(e) => {
                            addTimesRangeTo("femaleTime", e.target.value, 0);
                          }}
                          id={"femaleTo"}
                          name="femaleTo"
                          className={`form-control input time-input `}
                        />
                        <Label for="femaleTo" className="">
                          {"Female End Time"}
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </section>}

            </Row>}
          </div>
        </div>
      </div>
    </div>
  );
};
